module.exports = __webpack_public_path__ + "img/hzms_mobile_card.7c1a7037.png";